import { type KeyboardEvent, type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { cn, PaletteUtils } from '@shared/utils';

interface ButtonProps {
  // COMMON PROPS
  className?: string;
  view?: 'primary' | 'secondary';
  fullWidth?: boolean;
  icon?: ReactNode;
  caption?: ReactNode;
  active?: boolean;
  onClick?: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  // BASE LINK PROPS
  url?: string;
  exact?: boolean;
  replace?: boolean;
  // BASE PROPS BUTTON
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export const Button = (props: ButtonProps) => {
  if (props.url) {
    return (
      <NavLink
        className={cn(
          'flex h-10 w-fit cursor-pointer items-center justify-center border bg-transparent px-6 py-3 text-center text-sm leading-4 uppercase outline-none',
          PaletteUtils.isBordierPalette &&
            'border-[#dc291c] text-[#4d3b2d] hover:text-white font-semibold tracking-[1.97px] hover:bg-[#dc291c] hover:border-[#dc291c]',
          !PaletteUtils.isBordierPalette &&
            'border-[#6d6d75]  text-[#dadada] font-medium !text-base tracking-[1.7px] hover:!bg-transparent hover:border-[#e5c496]',
          props.fullWidth && 'w-full',
          props.active && 'bg-[#dc291c] text-white',
          props.disabled && 'border-[#6d6d75] text-[#6d6d75]',
          props.className,
        )}
        to={props.url}
        end={props.exact || true}
        replace={props.replace}
        onClick={props.onClick}
      >
        {props.icon}
        {props.caption}
      </NavLink>
    );
  }

  return (
    <button
      className={cn(
        'flex items-center justify-center h-10 w-fit cursor-pointer border bg-transparent px-6 py-3 text-center text-sm leading-4 uppercase outline-none',
        (!props.view || props.view === 'primary') && [
          PaletteUtils.isBordierPalette &&
            'border-[#dc291c] font-semibold tracking-[1.97px] text-[#4d3b2d] hover:border-[#dc291c] hover:bg-[#dc291c] hover:text-white',
          !PaletteUtils.isBordierPalette &&
            'border-[#6d6d75] font-medium tracking-[1.7px] text-[#dadada] hover:border-[#e5c496] hover:!bg-transparent',
        ],
        props.view === 'secondary' && [
          PaletteUtils.isBordierPalette &&
            'border-[#dc291c] font-semibold tracking-[1.97px] text-[#4d3b2d] hover:border-[#dc291c] hover:bg-[#dc291c] hover:text-white',
          !PaletteUtils.isBordierPalette && 'border-[#be8b45] font-semibold text-[#4c4c52] hover:border-[#e5c496] hover:text-[#4c4c52]/50',
        ],
        props.fullWidth && 'w-full',
        props.disabled && (PaletteUtils.isBordierPalette ? '' : '!cursor-default !border-[#6d6d75] !text-[#6d6d75]'),
        props.active && PaletteUtils.isBordierPalette ? '!bg-[#dc291c] !text-white' : '',
        props.className,
      )}
      type={props.type || 'button'}
      disabled={props.disabled}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
    >
      {props.icon}
      {props.caption}
    </button>
  );
};
